import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { saveAs } from 'file-saver';
import { interval } from 'rxjs';
import { Router } from '@angular/router';
import { MyserviceService } from '../myservice.service';
@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.css']
})
export class DownloadsComponent implements OnInit {

  constructor(private service: MyserviceService,private http: HttpClient, public session: SessionStorageService, public localstorage: LocalStorageService, private router: Router) {

  }

  loggedInUserDetails: any;
  reports: any = []
  jobcall: any;

  ngOnInit() {

    this.loggedInUserDetails = this.session.retrieve("UserDetails");

    this.apicall()
    this.jobcall = interval(120000).subscribe(() => {
      this.apicall()

    })
  }

  apicall() {
    let headers = new HttpHeaders();
    headers = headers.append("authorization", this.localstorage.retrieve("token"));
    this.service.getReports(this.loggedInUserDetails.userId, headers).subscribe((res: any) => {
      this.reports = res
      console.log(res)
    })
  }



  download(report: any) {
    report.loading = true
    let headers = new HttpHeaders();
    headers = headers.append("authorization", this.localstorage.retrieve("token"));
    this.loggedInUserDetails = this.session.retrieve("UserDetails");
    this.http.get(environment.apiUrl + "/documentRepository/downloadReport/" + report.fileName, { headers: headers, responseType: 'blob' as 'json' }).subscribe((res: any) => {

      const blob = new Blob(
        [res],
        {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      );

      saveAs(blob, report.fileName);
      report.loading = false
    })
  }
  refreshReports() {

    this.apicall()
  }

  ngOnDestroy() {
    this.jobcall.unsubscribe();
  }
}
